module.exports = __webpack_public_path__ + "img/r2.654ff05e.jpeg";